import { useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { TEndpoint, TReportType } from 'contexts/app-context/types'

import { useQuery } from '@tanstack/react-query'

import { getReportStatusQueryOptions } from './queries/getReportStatusQueryOptions'

export const useGetReportStatus = (reportType: TReportType) => {
  const { privacyCenterContent, isUSBranch, userCountry, userSelectedEntity } = useAppContext()

  const getReportStatusEndpoint: TEndpoint | undefined = useMemo(() => {
    const endpoint = privacyCenterContent?.endpoints?.reports?.getReportsStatus

    if (!endpoint) return undefined

    return endpoint
  }, [privacyCenterContent?.endpoints?.reports?.getReportsStatus])

  const { data, isLoading, isError } = useQuery(
    getReportStatusQueryOptions({
      endpoint: getReportStatusEndpoint,
      reportType,
      userCountry,
      userSelectedEntity,
      isUSBranch,
    }),
  )

  return { data, isLoading, isError }
}
